import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { imageBaseApi } from "../../../utilis/imageHelper";
import MediaModal from "../../PagesSection/Component/MediaModal";
import classnames from "classnames";
import FooterInfoService from "../../../services/KangarooServices/FooterInfoService";
import toast from "react-hot-toast";

const SOCIALS = [
  { key: "facebook", label: "Facebook" },
  { key: "instagram", label: "Instagram" },
  { key: "tikTok", label: "TikTok" },
  { key: "linkedIn", label: "LinkedIn" },
  { key: "youTube", label: "YouTube" },
  { key: "x", label: "X (Twitter)" },
];

const FooterInfoForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [isMediaOpen, setIsMediaOpen] = useState(false);
  const [activeMediaType, setActiveMediaType] = useState(null);
  const [mediaState, setMediaState] = useState({});
  const [initialData, setInitialData] = useState();
  const fetchDatabyId = async (id) => {
    try {
      const res = await FooterInfoService.getbyId(id);
      setInitialData(res);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDatabyId(id);
  }, [id]);
  const toggleMedia = (type = null) => {
    setActiveMediaType(type);
    setIsMediaOpen((p) => !p);
  };
  const [activeSocialTab, setActiveSocialTab] = useState("facebook");

  const toggleSocialTab = (tab) => {
    if (activeSocialTab !== tab) {
      setActiveSocialTab(tab);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: initialData?.name || "",
      address: initialData?.address || "",
      phone: initialData?.phone || "",
      email: initialData?.email || "",
      isActive: initialData?.isActive ?? true,
      isAddress: initialData?.isAddress ?? true,
      isTextOnly: initialData?.isTextOnly ?? false,

      facebookUrl: initialData?.facebookUrl || "",
      facebookImageId: initialData?.facebookImage?.id || "",
      instagramUrl: initialData?.instagramUrl || "",
      instagramImageId: initialData?.instagramImage?.id || "",
      tikTokUrl: initialData?.tikTokUrl || "",
      tikTokImageId: initialData?.tikTokImage?.id || "",
      linkedInUrl: initialData?.linkedInUrl || "",
      linkedInImageId: initialData?.linkedInImage?.id || "",
      youTubeUrl: initialData?.youTubeUrl || "",
      youTubeImageId: initialData?.youTubeImage?.id || "",
      xUrl: initialData?.xUrl || "",
      xImageId: initialData?.xImage?.id || "",
      orderIndex: initialData?.orderIndex,
    },

    onSubmit: async (values) => {
      // Base payload depending on isTextOnly
      let payload = values.isTextOnly
        ? {
            name: values.name,
            // orderIndex: values.orderIndex,
            isTextOnly: values.isTextOnly,
          }
        : {
            ...values,
            isAddress: values.isTextOnly ? false : values.isAddress,
          };

      // Remove null or empty string fields
      payload = Object.fromEntries(
        Object.entries(payload).filter(
          ([key, value]) => value !== null && value !== ""
        )
      );

      try {
        let response;
        if (id) {
          response = await FooterInfoService.update(id, payload);
        } else {
          response = await FooterInfoService.create(payload);
        }
        toast.success(response);
        navigate("/footer-info");
      } catch (error) {
        console.log(error);
      }
    },
  });

  // Populate initial media from initialData
  useEffect(() => {
    if (initialData) {
      setMediaState({
        facebook: initialData.facebookImage || null,
        instagram: initialData.instagramImage || null,
        tikTok: initialData.tikTokImage || null,
        linkedIn: initialData.linkedInImage || null,
        youTube: initialData.youTubeImage || null,
        x: initialData.xImage || null,
      });
    }
  }, [initialData]);

  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb
          title="Footer Info Form"
          pageTitle="Footer Info"
          breadcrumbItems={[{ title: "Back to List", link: "/footer-info" }]}
        />

        <form onSubmit={formik.handleSubmit}>
          <div className="d-flex justify-content-end mb-3 gap-2">
            <Button type="submit" color="success">
              {id ? "Update" : "Create"}
            </Button>
            <Button color="danger" onClick={() => navigate("/footer-info")}>
              Cancel
            </Button>
          </div>

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <FormGroup check className="mb-3">
                    <Input
                      type="checkbox"
                      checked={formik.values.isTextOnly}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        formik.setFieldValue("isTextOnly", checked);
                        if (checked) {
                          formik.setFieldValue("isAddress", false);
                        }
                      }}
                    />
                    <Label check className="ms-2">
                      Text Only (Copyright section)
                    </Label>
                  </FormGroup>
                  {/* NAME */}
                  {formik.values.isTextOnly ? (
                    <FormGroup>
                      <Label>Copyright Input</Label>
                      <Input
                        type="textarea"
                        rows={4}
                        name="name"
                        value={formik.values.name}
                        onChange={formik.handleChange}
                      />
                    </FormGroup>
                  ) : (
                    <FormGroup>
                      <Label>Name</Label>
                      <Input
                        name="name"
                        value={formik.values.name}
                        onChange={formik.handleChange}
                      />
                    </FormGroup>
                  )}
                  {/* TEXT ONLY */}

                  {/* <FormGroup>
                    <Label>Order Index</Label>
                    <Input
                      type="number"
                      name="orderIndex"
                      value={formik.values.orderIndex}
                      onChange={formik.handleChange}
                    />
                  </FormGroup> */}
                </CardBody>
              </Card>
              {!formik.values.isTextOnly && (
                <Card className="mt-4">
                  <CardBody>
                    <h5 className="mb-3">Social Media</h5>

                    {/* TAB HEADERS */}
                    <Nav tabs>
                      {SOCIALS.map(({ key, label }) => (
                        <NavItem key={key}>
                          <NavLink
                            className={classnames({
                              active: activeSocialTab === key,
                            })}
                            style={{ cursor: "pointer" }}
                            onClick={() => toggleSocialTab(key)}
                          >
                            {label}
                          </NavLink>
                        </NavItem>
                      ))}
                    </Nav>

                    {/* TAB CONTENT */}
                    <TabContent activeTab={activeSocialTab} className="mt-4">
                      {SOCIALS.map(({ key, label }) => {
                        const media = mediaState[key];

                        return (
                          <TabPane tabId={key} key={key}>
                            <FormGroup>
                              <Label>{label} URL</Label>
                              <Input
                                name={`${key}Url`}
                                value={formik.values[`${key}Url`]}
                                onChange={formik.handleChange}
                              />
                            </FormGroup>

                            <Label>{label} Image</Label>

                            {media ? (
                              <div className="border p-3 rounded text-center">
                                <img
                                  src={`${imageBaseApi}${media.url}`}
                                  className="img-fluid rounded mb-2"
                                  style={{ height: "200px" }}
                                />
                                <div className="d-flex justify-content-center gap-2">
                                  <Button
                                    size="sm"
                                    outline
                                    color="primary"
                                    onClick={() => toggleMedia(key)}
                                  >
                                    Change
                                  </Button>
                                  <Button
                                    size="sm"
                                    outline
                                    color="danger"
                                    onClick={() => {
                                      setMediaState((p) => ({
                                        ...p,
                                        [key]: null,
                                      }));
                                      formik.setFieldValue(`${key}ImageId`, "");
                                    }}
                                  >
                                    Remove
                                  </Button>
                                </div>
                              </div>
                            ) : (
                              <div className="text-center p-4 border rounded bg-light">
                                <i className="ri-image-add-line fs-1 text-secondary"></i>
                                <h6 className="mt-2 mb-2 text-muted">
                                  No media added
                                </h6>
                                {/* <h6 className="mb-3 text-muted">1200 x 630</h6> */}
                                <Button
                                  outline
                                  size="sm"
                                  color="secondary"
                                  className="rounded-pill px-3"
                                  onClick={() => toggleMedia(key)}
                                >
                                  <i className="ri-image-add-line me-1"></i> Add
                                  Media
                                </Button>
                              </div>
                            )}
                          </TabPane>
                        );
                      })}
                    </TabContent>
                  </CardBody>
                </Card>
              )}
            </Col>
            {/* <Col>
              {!formik.values.isTextOnly && (
                <Card>
                  <CardBody>
                   
                    <FormGroup>
                      <Label>Email</Label>
                      <Input
                        type="email"
                        name="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>Phone</Label>
                      <Input
                        name="phone"
                        value={formik.values.phone}
                        onChange={formik.handleChange}
                      />
                    </FormGroup>

                    <FormGroup>
                      <Label>Address</Label>
                      <Input
                        type="textarea"
                        rows={4}
                        name="address"
                        value={formik.values.address}
                        onChange={formik.handleChange}
                      />
                    </FormGroup>
                  </CardBody>
                </Card>
              )}
            </Col> */}
          </Row>
        </form>
      </div>

      {/* MEDIA MODAL */}
      <MediaModal
        isOpen={isMediaOpen}
        toggle={() => setIsMediaOpen(false)}
        setSelectedMedia={(media) => {
          if (!activeMediaType) return;

          setMediaState((p) => ({
            ...p,
            [activeMediaType]: media,
          }));

          formik.setFieldValue(`${activeMediaType}ImageId`, media?.id || "");
        }}
      />
    </Container>
  );
};

export default FooterInfoForm;
